/**
* @prop --uic-list-border: The border of the list
* @prop --uic-list-background: The background of the list
* @prop --uic-list-box-shadow: The shadow of the list
*/

uic-list {
  background: var(--uic-list-background, #fff);
  border: var(--uic-list-border);
  box-shadow: var(--uic-list-box-shadow);
  box-sizing: border-box;
  display: block;
  height: 100%;
  padding: 0;
}
